export const deliContainerProducts = [
  {
    "Item #": "2536-5884",
    "Description": "PET Round Deli",
    "Dimensions": "4.65” x 4.65” x 1.69”",
    "Fluid oz": 8,
    "Qty/case": 430,
    "Case/pallet": 30,
    "Availability": "In Stock",
    "Compartments": 1,
    "Price Per Case": "$75.32",
    "Image URL": "https://teinnovations.com/wp-content/catalog-images/deli-containers/8oz.png"
  },
  {
    "Item #": "2536-5892",
    "Description": "PET Round Deli",
    "Dimensions": "4.65” x 4.65” x 2.39”",
    "Fluid oz": 12,
    "Qty/case": 430,
    "Case/pallet": 30,
    "Availability": "In Stock",
    "Compartments": 1,
    "Price Per Case": "$78.45",
    "Image URL": "https://teinnovations.com/wp-content/catalog-images/deli-containers/12oz.png"
  },
  {
    "Item #": "2536-5893",
    "Description": "PET Round Deli",
    "Dimensions": "4.65” x 4.65” x 2.90”",
    "Fluid oz": 16,
    "Qty/case": 430,
    "Case/pallet": 30,
    "Availability": "In Stock",
    "Compartments": 1,
    "Price Per Case": "$79.68",
    "Image URL": "https://teinnovations.com/wp-content/catalog-images/deli-containers/16oz.png"
  },
  {
    "Item #": "2536-5891",
    "Description": "PET Round Lid",
    "Dimensions": "4.8” x .455”",
    "Fluid oz": "N/A",
    "Qty/case": 860,
    "Case/pallet": 30,
    "Availability": "In Stock",
    "Compartments": 1,
    "Price Per Case": "$58.78",
    "Image URL": "https://teinnovations.com/wp-content/catalog-images/deli-containers/pet-lid.webp"
  },
  {
    "Item #": "2337-2057",
    "Description": "PP Deli",
    "Dimensions": "4.58” x 1.82”",
    "Fluid oz": 8,
    "Qty/case": 500,
    "Case/pallet": 48,
    "Availability": "In Stock",
    "Compartments": 1,
    "Price Per Case": "$32.84",
    "Image URL": "https://teinnovations.com/wp-content/catalog-images/deli-containers/8oz_2.png"
  },
  {
    "Item #": "2337-2049",
    "Description": "PP Deli",
    "Dimensions": "4.58” X 2.29”",
    "Fluid oz": 12,
    "Qty/case": 500,
    "Case/pallet": 40,
    "Availability": "In Stock",
    "Compartments": 1,
    "Price Per Case": "$39.92",
    "Image URL": "https://teinnovations.com/wp-content/catalog-images/deli-containers/12oz_2.png"
  },
  {
    "Item #": "2337-2053",
    "Description": "PP Deli",
    "Dimensions": "4.58” x 2.98”",
    "Fluid oz": 16,
    "Qty/case": 500,
    "Case/pallet": 32,
    "Availability": "In Stock",
    "Compartments": 1,
    "Price Per Case": "$45.35",
    "Image URL": "https://teinnovations.com/wp-content/catalog-images/deli-containers/16oz_2.png"
  },
  {
    "Item #": "2337-2051",
    "Description": "PP Deli",
    "Dimensions": "4.58” x 4.33”",
    "Fluid oz": 24,
    "Qty/case": 500,
    "Case/pallet": 32,
    "Availability": "Not In Stock",
    "Compartments": 1,
    "Price Per Case": "$55.65",
    "Image URL": "https://teinnovations.com/wp-content/catalog-images/deli-containers/24oz.png"
  },
  {
    "Item #": "2337-2055",
    "Description": "PP Deli",
    "Dimensions": "4.58” x 5.73”",
    "Fluid oz": 32,
    "Qty/case": 500,
    "Case/pallet": 32,
    "Availability": "Not In Stock",
    "Compartments": 1,
    "Price Per Case": "$62.41",
    "Image URL": "https://teinnovations.com/wp-content/catalog-images/deli-containers/32oz.png"
  },
  {
    "Item #": "2537-2049",
    "Description": "PE Natural Plain Lid",
    "Dimensions": "N/A",
    "Fluid oz": "N/A",
    "Qty/case": 500,
    "Case/pallet": 48,
    "Availability": "In Stock",
    "Compartments": "N/A",
    "Price Per Case": "$43.08",
    "Image URL": "https://teinnovations.com/wp-content/catalog-images/deli-containers/natural-lid.webp"
  }
];
